document.addEventListener("DOMContentLoaded", function () {
  if (!document.body.classList.contains("template-policy")) return;

  const policyBody = document.querySelector(".shopify-policy__body");
  if (!policyBody) return;


  /* =========================================================
     PAGE DETECTION
     ========================================================= */


  /* Shipping page */

  if (window.location.pathname.indexOf("/policies/shipping-policy") !== -1) {
    document.body.classList.add("iodine-policy-page--shipping");

    const title = document.querySelector(".shopify-policy__title h1");

    if (title) {
      title.textContent = "SHIPPING + DELIVERY";
    }
  }


  /* Returns page */

  if (window.location.pathname.indexOf("/policies/refund-policy") !== -1) {
    document.body.classList.add("iodine-policy-page--returns");

    const title = document.querySelector(".shopify-policy__title h1");

    if (title) {
      title.textContent = "RETURNS + ORDER ISSUES";
    }
  }


  /* Privacy page */

  if (window.location.pathname.indexOf("/policies/privacy-policy") !== -1) {
    document.body.classList.add("iodine-policy-page--privacy");

    const title = document.querySelector(".shopify-policy__title h1");

    if (title) {
      title.textContent = "PRIVACY + DATA";
    }
  }

  /* Terms page */

if (window.location.pathname.indexOf("/policies/terms-of-service") !== -1) {
  document.body.classList.add("iodine-policy-page--terms");

  const title = document.querySelector(".shopify-policy__title h1");

  if (title) {
    title.textContent = "TERMS + CONDITIONS";
  }
}

  /* =========================================================
     AUTOMATED PRIVACY POLICY PRESENTATION
     ========================================================= */

  if (document.body.classList.contains("iodine-policy-page--privacy")) {
    const rte = document.querySelector(".shopify-policy__body .rte");

    if (rte && !rte.querySelector(".iodine-policy--privacy")) {
      const originalNodes = Array.from(rte.childNodes);

      const policy = document.createElement("div");
      policy.className = "iodine-policy iodine-policy--privacy";

      const intro = document.createElement("div");
      intro.className = "iodine-policy__intro iodine-policy__intro--privacy";

      const details = document.createElement("div");
      details.className = "iodine-policy__details iodine-policy__details--privacy";

      let currentSection = null;
      let lastUpdatedNode = null;
      let reachedFirstHeading = false;

      originalNodes.forEach(function (node) {
        const isElement = node.nodeType === Node.ELEMENT_NODE;
        const tagName = isElement ? node.tagName : "";
        const text = node.textContent ? node.textContent.trim() : "";

        /* Save Shopify's dynamic Last updated line for the outro */

        if (
          !reachedFirstHeading &&
          text.toLowerCase().indexOf("last updated:") === 0
        ) {
          lastUpdatedNode = node;
          return;
        }


        /* Everything before the first H2 becomes the intro */

        if (!reachedFirstHeading && tagName !== "H2") {
          intro.appendChild(node);
          return;
        }


        /* Each H2 begins a new policy section */

        if (tagName === "H2") {
          reachedFirstHeading = true;

          currentSection = document.createElement("div");
          currentSection.className = "iodine-policy__section";

          currentSection.appendChild(node);
          details.appendChild(currentSection);

          return;
        }


        /* Everything after an H2 belongs to that section */

        if (currentSection) {
          currentSection.appendChild(node);
        } else {
          details.appendChild(node);
        }
      });


      policy.appendChild(intro);
      policy.appendChild(details);


      /* Privacy contact bar */

      const contactBar = document.createElement("div");

      contactBar.className =
        "iodine-policy__section iodine-policy__section--contact iodine-policy__privacy-contact";

      contactBar.innerHTML = `
        <h2>NEED THERAPY AFTER READING THIS?</h2>

        <p>
  Policy is boring as fuck. You should go listen to
  <a
    class="iodine-policy__release-link"
    href="/products/horsewhip-consume-and-burn"
  >Horsewhip 'Consume and Burn'</a>
  to clear your head.
</p>

        <p>
          <a
            class="iodine-policy__contact-link"
            href="mailto:info@iodinerecords.com"
          >
            <span>Contact Iodine</span>
            <span
              class="iodine-policy__contact-arrow"
              aria-hidden="true"
            >→</span>
          </a>
        </p>
      `;

      details.appendChild(contactBar);

      /* Warehouse outro */

      const outro = document.createElement("div");
      outro.className = "iodine-policy__outro";

      outro.innerHTML = `
        <div class="iodine-policy__warehouse-heading">
          <strong>FROM THE WAREHOUSE</strong>
          <span>BOSTON, MA</span>
        </div>

        <div class="iodine-policy__warehouse-image">
          <img
            src="https://cdn.shopify.com/s/files/1/0550/1642/3595/files/Warehouse-Shot.jpg?v=1786829532"
            alt="Rows of vinyl records in the Iodine warehouse"
            loading="lazy"
          >
        </div>

        <p class="iodine-policy__warehouse-meta">
          IODINE MAILORDER / BOSTON MA / EST. 1998
        </p>

        <div class="iodine-policy__outro-nav">

          <a
            <a
  class="iodine-policy__back-store"
  href="/pages/consume"
          >
            <span>Back to the Store</span>
            <span
              class="iodine-policy__back-arrow"
              aria-hidden="true"
            >→</span>
          </a>

          <p class="iodine-policy__outro-copy">
            Browse new releases, catalog titles, merch + more.
          </p>

        </div>
      `;


      /* Reuse Shopify's own dynamic Last updated date */

      if (lastUpdatedNode) {
        const updated = document.createElement("p");
        updated.className = "iodine-policy__updated";

        const small = document.createElement("small");
        small.textContent = lastUpdatedNode.textContent.trim();

        updated.appendChild(small);
        outro.appendChild(updated);
      }


      policy.appendChild(outro);

      rte.innerHTML = "";
      rte.appendChild(policy);
    }
  }


  /* =========================================================
     POLICY SECTION ANCHORS
     ========================================================= */

  /*
   * Shopify's policy editor may not retain reliable anchor targets,
   * so assign them from the visible section headings.
   */

  const anchorMap = {

    /* Shipping */

    "ORDER PROCESSING": "order-processing",
    "PRE-ORDERS": "preorders",
    "U.S. SHIPPING": "domestic-shipping",
    "INTERNATIONAL SHIPPING: PLEASE READ BEFORE ORDERING": "international",
    "VAT, CUSTOMS, DUTIES + IMPORT FEES": "customs",
    "CANADA": "canada",
    "EUROPEAN UNION": "european-union",
    "UNITED KINGDOM": "united-kingdom",
    "AUSTRALIA + OTHER INTERNATIONAL DESTINATIONS": "australia-other",
    "SHIPPING ADDRESS CHANGES": "address-changes",
    "TRACKING + DELAYED PACKAGES": "tracking",
    "TRACKING SAYS DELIVERED, BUT I DON'T HAVE MY PACKAGE": "delivered-missing",
    "RETURNED-TO-SENDER PACKAGES": "returned-packages",
    "DAMAGED, DEFECTIVE, MISSING OR INCORRECT ORDERS": "damaged-orders",

    /* Returns */

    "DAMAGED, DEFECTIVE + INCORRECT ORDERS": "damaged-orders",
    "VINYL + DAMAGED JACKETS": "vinyl",
    "LIMITED + SOLD-OUT VARIANTS": "limited-variants",
    "RETURNS + FINAL SALE ITEMS": "returns",
    "CLOTHING + SIZE EXCHANGES": "exchanges",
    "CANCELLATIONS": "cancellations",
    "REFUNDS": "refunds",
    "EUROPEAN UNION CUSTOMERS": "european-union",
    "PACKING AN AUTHORIZED RETURN": "packing-returns",
    "ORDERS PLACED THROUGH OTHER STORES": "other-stores",

    /* Shared */

    "STILL CONFUSED?": "contact"
  };


  policyBody.querySelectorAll("h2").forEach(function (heading) {
    const text = heading.textContent.trim().toUpperCase();

    if (anchorMap[text]) {
      heading.id = anchorMap[text];
    }
  });


  /* =========================================================
     SMOOTH ANCHOR NAVIGATION
     ========================================================= */

  policyBody
    .querySelectorAll('.iodine-policy__jump-nav a[href^="#"]')
    .forEach(function (link) {
      link.addEventListener("click", function (event) {
        const target = document.querySelector(link.getAttribute("href"));

        if (!target) return;

        event.preventDefault();

        target.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });

        history.replaceState(null, "", link.getAttribute("href"));
      });
    });
});